import React, {useState, useEffect} from 'react';
import Method from "../components/Method";
import Attributes from "../components/Attributes";
import Layout from "../layout";
import axios from "axios";
import {API} from "../../../config";

const RatesCoordinate = (props) => {
    const [ areaLoadingSingle, setAreaLoadingSingle ] = useState(false);
    const [ areaLoadingDouble, setAreaLoadingDouble ] = useState(false);
    const [ areaInput, setAreaInput ] = useState('');
    const [ areas, setAreas ] = useState([]);
    const [ selectedArea, setSelectedArea ] = useState({
        filled:false
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            searchPlace ( areaInput ).then (  r => setAreas(r.data.areas))
            // Send Axios request here
        }, 500);

        return () => clearTimeout(delayDebounceFn)
    }, [areaInput])

    const onChange = name => async e => {
        setAreaLoadingSingle(true);
        setAreaInput(e.target.value);
        setSelectedArea({filled:false})
    };

    const searchPlace = async (value) => {
        try {
            const res = await axios.get(`${API}/v1/maps/areas?countries=ID&input=${value}&type=single`, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                }
            });
            setAreaLoadingSingle(false);
            return res
        } catch (e) {
            console.log (e)
        }
        setAreaLoadingSingle(false)
    };

    const onSelectArea = i => {
        setAreas([])
        setAreaInput(i.name);
        setSelectedArea({
            filled:true,
            id:i.id,
            name:i.name,
            countryCode:i.country_code,
            countryName:i.country_name,
            adm1name:i.administrative_division_level_1_name,
            adm1type:i.administrative_division_level_1_type,
            adm2name:i.administrative_division_level_2_name,
            adm2type:i.administrative_division_level_2_type,
            adm3name:i.administrative_division_level_3_name,
            adm3type:i.administrative_division_level_3_type,
            adm4name:i.administrative_division_level_4_name,
            adm4type:i.administrative_division_level_4_type,
            postalCode:i.postal_code
        })
    };

    const selectedAreaView = () => {
        return (
            <div>
                <br/>
                <Method title={"RESPONSE"} white>
                    <text className="pl-4">{`{`}</text><br/>
                    <text className="pl-4"><text className="pl-4"/>"id": <text className="text-primary">"{selectedArea.id}"</text>,</text><br/>
                    <text className="pl-4"><text className="pl-4"/>"name": <text className="text-primary">"{selectedArea.name}"</text>,</text><br/>
                    <text className="pl-4"><text className="pl-4"/>"country_name": <text className="text-primary">"{selectedArea.countryName}"</text></text><br/>
                    <text className="pl-4"><text className="pl-4"/>"country_code": <text className="text-primary">"{selectedArea.countryCode}"</text></text><br/>
                    <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_name": <text className="text-primary">"{selectedArea.adm1name}"</text></text>,<br/>
                    <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_type": <text className="text-primary">"{selectedArea.adm1type}"</text></text>,<br/>
                    <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_name": <text className="text-primary">"{selectedArea.adm2name}"</text></text>,<br/>
                    <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_type": <text className="text-primary">"{selectedArea.adm2type}"</text></text>,<br/>
                    <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_name": <text className="text-primary">"{selectedArea.adm3name}"</text></text>,<br/>
                    <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_type": <text className="text-primary">"{selectedArea.adm3type}"</text></text>,<br/>
                    <text className="pl-4"><text className="pl-4"/>"postal_code": <text className="text-success">{selectedArea.postalCode}</text></text><br/>
                    <text className="pl-4">{`}`}</text><br/>
                </Method>
            </div>
        )
    }

    return (
        <Layout children={props.children} location={props.location}>
            <div className="row">
                <div className="col-md-8">
                    <h1>Single Search Area</h1>
                    <br/>
                    <p>
                        This API will show you the name of the area. By simply send your input then we will send you the list of area corresponding to your input. The autocomplete will help to find the area more efficient and easy.
                    </p>
                    <Method title={"ENDPOINTS"}>
                        <p><b className="text-info">GET</b> /v1/maps/areas?countries=<text className="text-info">ID</text>&input=<text className="text-info">Jakarta+Selatan</text>&type=<text className="text-info">single</text></p>
                    </Method>
                    <br/>
                    <h2 className="h3">Try Demo</h2>
                    <p>
                       You can create something like this to be part of your website.<br/>
                       <b className="text-danger">NOTE:</b> Please trigger your call function after user has done writing. Otherwise it will slow down your response due to multiple calls.
                    </p>
                    <form>
                        <label>The <b>Single</b> Type</label>
                        <div className="form-row">
                            <div className="col-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Type area here"
                                    onChange={onChange('input')}
                                    value={areaInput}
                                />
                                {
                                    areaLoadingSingle ?
                                        <div className="card mt-1">
                                            <text className="text-muted">Area Loading...</text>
                                        </div> : areas.length > 0 ?
                                        <div className="card mt-1">
                                            {
                                                areas.map(i => (
                                                    <div onClick={() => onSelectArea(i)} className="docs-area pointer p-2 border-bottom">
                                                        <a>{i.name}</a>
                                                    </div>
                                                ))
                                            }
                                        </div> : null
                                }
                            </div>
                        </div>
                    </form>
                    { selectedArea.filled ? selectedAreaView() : null}
                    <br/>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">Parameters</h2>
                    <br/>
                    <Attributes data={parameters}/>
                    <br/>

                    <br/>
                    <p>
                        The courier object sent from Biteship will look like following
                    </p>
                    <Method title={"RESPONSE"} white>
                        <text>{`{`}</text><br/>
                        <text className="pl-4">"success": <text className="text-swift-pink"><b>true</b></text>,</text><br/>
                        <text className="pl-4">"object": <text className="text-primary">"area"</text>,</text><br/>
                        <text className="pl-4">"areas": {`[{`}</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"id": <text className="text-primary">"IDNP6IDNC148IDND842IDZ12520"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"name": <text className="text-primary">"Pasar Minggu, Jakarta Selatan, DKI Jakarta. 12520"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"country_name": <text className="text-primary">"Indonesia"</text></text><br/>
                        <text className="pl-4"><text className="pl-4"/>"country_code": <text className="text-primary">"ID"</text></text><br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_name": <text className="text-primary">"DKI Jakarta"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_type": <text className="text-primary">"province"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_name": <text className="text-primary">"Jakarta Selatan"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_type": <text className="text-primary">"city"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_name": <text className="text-primary">"Pasar Minggu"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_type": <text className="text-primary">"district"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_4_name": <text className="text-primary">"Pasar Minggu"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_4_type": <text className="text-primary">"subdistrict"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"postal_code": <text className="text-success">12520</text></text><br/>
                        <text className="pl-4">{`},{`}</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"id": <text className="text-primary">"IDNP6IDNC148IDND837IDZ12530"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"name": <text className="text-primary">"Jagakarsa, Jakarta Selatan, DKI Jakarta. 12530"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"country_name": <text className="text-primary">"Indonesia"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"country_code": <text className="text-primary">"ID"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_name": <text className="text-primary">"DKI Jakarta"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_type": <text className="text-primary">"province"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_name": <text className="text-primary">"Jakarta Selatan"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_type": <text className="text-primary">"city"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_name": <text className="text-primary">"Jagakarsa"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_type": <text className="text-primary">"district"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_4_name": <text className="text-primary">"Tanjung Barat"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_4_type": <text className="text-primary">"subdistrict"</text></text><br/>
                        <text className="pl-4"><text className="pl-4"/>"postal_code": <text className="text-success">12530</text></text><br/>
                        <text className="pl-4">{`}`},</text><br/>
                        <text className="pl-4">{`{...}`},</text><br/>
                        <text className="pl-4">{`{...}`}</text><br/>
                        <text className="pl-4">{`]`}</text><br/>
                        <text>{`}`}</text><br/>
                    </Method>
                </div>
            </div>
            <br/>
            <br/>
        </Layout>
    )
};

const parameters = [{
    name:'countries',
    type:'string',
    required:true,
    description:'Country restriction. Please add at least one country so you can have a better result'
},{
    name:'input',
    type:'string',
    required:true,
    description:'The search input'
},{
    name:'type',
    type:'string',
    required:true,
    description:'Type of search input'
}];

export default RatesCoordinate
